export const SSN_TYPE = 'SSN'
export const ID_TYPE = 'ID'
export const MASK_CHAR_NUMBER = 8
export const MASK_PATTERN = '\\*\\*\\*-\\*\\*-1111'
export const IDENTIFICATION_NUMBER = '111-111-1111'
export const TAX_ID_NUMBER = '111-111-1111'
export const INCOME_TAX_DATE = '11/11'
export const PERCENTAGE = '111%'
export const DECIMAL = '%'
export const DATE = '11/11/1111'
export const YEAR = '1111'



// WEBPACK FOOTER //
// ./src/utils/fieldMasking.js